import { SettingsField } from "@/Components/WebsiteSettings/SettingsCard";
import RadioButtonGroup from "@/Components/Input/RadioButtonGroup";
import useCommon from "@/shared/hooks/useCommon";
import { AccountRequirementEnum } from "@/shared/utils/enum";
import { Controller, useFormContext } from "react-hook-form";

const AccountRequirement = () => {
  const tCommon = useCommon();
  const { control } = useFormContext();

  return (
    <SettingsField
      data-tour="website-settings.account"
      label={tCommon("customerAccountRequirement")}
    >
      <Controller
        name="accountRequirement"
        control={control}
        render={({ value, onChange }) => (
          <RadioButtonGroup
            onChange={(e) => onChange(parseInt(e.target.value))}
            value={value}
            direction="column"
            options={[
              {
                value: AccountRequirementEnum.NO_REQUIREMENT,
                label: tCommon("noRequirement"),
              },
              {
                value: AccountRequirementEnum.REQUIRED_FOR_OFFLINE_PAYMENT,
                label: tCommon("accountRequiredForOfflinePayment"),
              },
              {
                value: AccountRequirementEnum.ACCOUNT_REQUIRED_FOR_ALL_ORDERS,
                label: tCommon("accountRequiredForAllOrders"),
              },
            ]}
          />
        )}
      />
    </SettingsField>
  );
};

export default AccountRequirement;
